function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 464 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 463.491,
    height: 42.812,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.283,5.353l-6.827,32.106l2.64,0l6.827,-32.106l-2.64,-0Zm-3.467,-0l-6.826,32.106l2.373,0l6.827,-32.106l-2.374,-0Zm-3.2,-0l-6.826,32.106l2.106,0l6.827,-32.106l-2.107,-0Zm-2.933,-0l-6.827,32.106l1.84,0l6.827,-32.106l-1.84,-0Zm-2.667,-0l-6.826,32.106l1.573,0l6.827,-32.106l-1.574,-0Zm-2.4,-0l-6.826,32.106l1.306,0l6.827,-32.106l-1.307,-0Zm-2.133,-0l-6.827,32.106l1.04,0l6.827,-32.106l-1.04,-0Zm-1.84,-0l-6.827,32.106l0.774,0l6.826,-32.106l-0.773,-0Zm-1.6,-0l-6.827,32.106l0.507,0l6.827,-32.106l-0.507,-0Zm-1.333,-0l-6.8,32.106l0.24,0l6.8,-32.106l-0.24,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.19,37.459l45.04,0l6.826,-32.106l-45.04,-0l-6.826,32.106Zm42.32,-3.866l-37.947,-0l5.173,-24.374l37.947,0l-5.173,24.374Zm-20.134,-19.147l-2.96,13.92l10.427,-0l2.96,-13.92l-10.427,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.416,24.979l3.467,-2.853l2.747,-12.907l-37.947,0l-5.173,24.374l13.76,-0l1.813,-8.614l21.333,0Zm-40.426,12.48l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Zm6.293,-29.76l43.387,0l0.506,-2.346l-43.386,-0l-0.507,2.346Zm15.04,6.747l10.427,-0l-1.12,5.307l-10.427,-0l1.12,-5.307Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.696,33.593l35.52,-0l1.174,-5.574l-21.76,0l0.826,-3.866l21.04,-0l1.174,-5.574l-21.04,0l0.8,-3.786l21.76,-0l1.2,-5.574l-35.52,0l-5.174,24.374Zm-3.52,3.866l40.934,0l0.48,-2.346l-40.934,-0l-0.48,2.346Zm6.294,-29.76l40.96,0l0.506,-2.346l-40.96,-0l-0.506,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.643,33.593l13.76,-0l5.173,-24.374l-13.76,0l-3.013,14.187l-7.413,-14.187l-13.76,0l-5.174,24.374l13.76,-0l3.014,-14.214l7.413,14.214Zm-21.413,-25.894l43.386,0l0.507,-2.346l-43.387,-0l-0.506,2.346Zm-6.294,29.76l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.216,7.699l3.2,0l0.507,-2.346l-3.2,-0l-0.507,2.346Zm-6.293,29.76l3.173,0l0.48,-2.346l-3.173,-0l-0.48,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 186.835,
    y: 35.126,
    width: 21.727,
    height: 2.334,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.965,
    y: 5.353,
    width: 21.727,
    height: 2.334,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.794,5.353l-43.387,-0l-6.8,32.106l43.36,0l6.827,-32.106l-43.387,-0l43.387,-0Zm-5.6,13.466l2.053,-9.6l-37.947,0l-5.173,24.374l13.76,-0l2.027,-9.547l7.68,-0l0.72,9.547l13.76,-0l-1.04,-10.614l4.16,-4.16Zm-14.72,0l-9.467,0l0.933,-4.373l10.427,-0l-0.72,3.36l-1.173,1.013Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.625,19.134l-10.626,-0l-0.758,4.544l10.626,0l0.758,-4.544Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.408,33.593l13.76,-0l2.027,-9.547l10.426,-0l-2.026,9.547l13.76,-0l5.173,-24.374l-37.947,0l-5.173,24.374Zm-3.52,3.866l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Zm6.293,-29.76l43.387,0l0.507,-2.346l-43.387,-0l-0.507,2.346Zm15.04,6.747l10.427,-0l-0.933,4.373l-10.427,0l0.933,-4.373Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.408,14.446l10.427,-0l-1.04,4.907l13.76,-0l2.16,-10.134l-37.947,0l-5.173,24.374l37.946,-0l2.374,-11.2l-13.76,-0l-1.28,5.973l-10.427,-0l2.96,-13.92Zm-21.333,23.013l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Zm6.293,-29.76l43.387,0l0.506,-2.346l-43.386,-0l-0.507,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.781,33.593l13.76,-0l5.174,-24.374l-13.76,0l-5.174,24.374Zm2.774,-25.894l19.2,0l0.506,-2.346l-19.2,-0l-0.506,2.346Zm-6.294,29.76l19.174,0l0.48,-2.346l-19.174,-0l-0.48,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.968,33.593l13.76,-0l5.173,-24.374l-13.76,0l-3.013,14.187l-7.413,-14.187l-13.76,0l-5.174,24.374l13.76,-0l3.014,-14.214l7.413,14.214Zm-21.413,-25.894l43.386,0l0.507,-2.346l-43.387,-0l-0.506,2.346Zm-6.294,29.76l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.635,24.046l5.546,-0l-0.933,4.32l-10.427,-0l2.96,-13.92l10.427,-0l-0.507,2.347l13.76,-0l1.627,-7.574l-37.947,0l-5.173,24.374l37.947,-0l3.12,-14.774l-19.307,0l-1.093,5.227Zm-17.894,-16.347l43.387,0l0.507,-2.346l-43.387,-0l-0.507,2.346Zm-6.293,29.76l43.36,0l0.48,-2.346l-43.36,-0l-0.48,2.346Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.368,5.353l-6.827,32.106l2.64,0l6.827,-32.106l-2.64,-0Zm3.733,-0l-6.826,32.106l2.373,0l6.827,-32.106l-2.374,-0Zm3.467,-0l-6.827,32.106l2.107,0l6.827,-32.106l-2.107,-0Zm3.2,-0l-6.827,32.106l1.84,0l6.827,-32.106l-1.84,-0Zm2.933,-0l-6.826,32.106l1.573,0l6.827,-32.106l-1.574,-0Zm2.667,-0l-6.827,32.106l1.307,0l6.827,-32.106l-1.307,-0Zm2.4,-0l-6.827,32.106l1.04,0l6.827,-32.106l-1.04,-0Zm2.107,-0l-6.827,32.106l0.773,0l6.827,-32.106l-0.773,-0Zm1.866,-0l-6.826,32.106l0.506,0l6.827,-32.106l-0.507,-0Zm1.6,-0l-6.826,32.106l0.24,0l6.826,-32.106l-0.24,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ceed4b57615ea1ba056b86ca8170a65e.svg";
export { ForwardRef as ReactComponent };